export const NumberFormat = (number: number) => {
  return parseFloat(`${number}`)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1,`);  
};

export function formatNumberWithCommas(value: string) {
  const [integer, decimal] = value.split(".");
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimal ? `${formattedInteger}.${decimal}` : formattedInteger;
}

export const PriceFormatter = (value: string) => {
  if (!value) return "";
  const numberValue = parseFloat(value.replace(/,/g, "")); // Parse the input string to a number
  // Check if the parsed value is a valid number
  if (!isNaN(numberValue)) {
    // Format the number as a price using Intl.NumberFormat
    return new Intl.NumberFormat("en-AE", {
      style: "currency",
      currency: "AED",
      maximumFractionDigits: 2,
    }).format(numberValue);
  }
  return value;
};
